export default "__VITE_ASSET__ZZyFmrK3__"